/* eslint-disable */
import BaseService from "../../../BaseService";
const { http } = BaseService();
const controller = "LoaiQuyetDinhCongTac";
// API
export function HinhThucChuyenCongTacGetAll(postdata) {
  const data = { ...postdata };
  return http({
    url: controller + "/GetAll",
    method: "post",
    data,
  });
}

export function GetPagingParams(postdata) {
  const data = { ...postdata };
  return http({
    url: controller + "/get-paging-params",
    method: "post",
    data,
  });
}

export function HinhThucChuyenCongTacCreate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: controller + "/Create",
    method: "post",
    data,
  });
}

export function HinhThucChuyenCongTacUpdate(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: controller + "/Update",
    method: "post",
    data,
  });
}

export function HinhThucChuyenCongTacDelete(postdata) {
  const data = Object.assign({}, postdata);
  return http({
    url: "HinhThucChuyenCongTac/Delete",
    method: "post",
    data,
  });
}
